module.exports = __webpack_public_path__ + "static/media/luka.a5ca6ccd.jpg";